/**
 * PATH: packages/ui/src/kanban/components/teams-thread/MessageBody.tsx
 * FILE_ID: UI-KANBAN-TEAMS-THREAD-001
 * PURPOSE: Team-chat message body — thin wrapper over shared CommentBody
 *   (link chips + @mention highlights).
 * WHY: Extracted from CardTeamsThreadSection; FEAT-2026-07-06-KANBAN-COMMENT-
 *   LINKS unified rendering into comment-text/CommentBody. This file keeps
 *   the teams-thread public API (`MessageBody`, `memberLabel`) stable.
 */
import type { KanbanMember } from '../../api'
import { CommentBody, memberLabel } from '../comment-text'

export { memberLabel }

/**
 * Render a message body with `@token` runs as bold spans and URLs as
 * short-form clickable chips. Bridges the raw text the API stores with a
 * Trello-style "@Mark" highlight without pulling in a markdown renderer.
 */
export function MessageBody({
  content,
  mentions,
  membersById,
  currentUserId,
}: {
  content: string
  mentions: number[]
  membersById: Map<number, KanbanMember>
  currentUserId?: number | null
}) {
  return (
    <CommentBody
      text={content}
      mentionIds={mentions}
      membersById={membersById}
      currentUserId={currentUserId}
    />
  )
}
